<aims-navmenu></aims-navmenu>

<router-outlet></router-outlet>